/*
 *
 *
 *  Modal logic and PDP modal related logic
 *
 *
 */

function patchModal() {
    var modal_open_trigger = document.querySelector(".js-trigger-patch-modal");
    var modal_overlay = document.querySelector(".js-patch-modal-overlay");
    var modal_container = document.querySelector(".js-patch-draw");
    var modal_close_triggers = Array.prototype.slice.call(
        document.querySelectorAll(".js-patch-close")
    );
    var add_patches_trigger = document.querySelector(".js-add-patch-trigger");
    var body = document.querySelector("body");

    if (modal_open_trigger) {
        modal_open_trigger.addEventListener("click", openModal);
    }

    if (!!modal_overlay) {
        modal_overlay.addEventListener("click", function (event) {
            if (event.target == modal_overlay) closeModal();
        });
    }

    if (!!modal_close_triggers) {
        modal_close_triggers.forEach(function (el) {
            el.addEventListener("click", closeModal);
        });
    }

    if (!!add_patches_trigger)
        add_patches_trigger.addEventListener("click", closeModal);

    function closeModal() {
        body.classList.remove("no-scroll");
        modal_container.classList.add("is-hidden");
        setTimeout(function () {
            modal_overlay.classList.add("is-hidden");
        }, 300);
    }

    function openModal() {
        body.classList.add("no-scroll");
        modal_overlay.classList.remove("is-hidden");
        setTimeout(function () {
            modal_container.classList.remove("is-hidden");
        }, 300);
    }

    function addPatches() {
        if (!!add_patches_trigger)
            add_patches_trigger.addEventListener("click", addToArray);
    }

    function addToArray() {
        var itemsList = [];
        var patches = Array.prototype.slice.call(
            document.querySelectorAll(".js-patch-item")
        );
        var main_product_input = document.querySelector(
            'form[action="/cart/add"] input[name="id"]:not(.js-add-main-product)'
        );
        var main_product_quantity = document.querySelector(
            ".quantity-selector__input"
        );
        var item = {};
        item.id = main_product_input.value;
        item.quantity = main_product_quantity.value;
        itemsList.push(item);

        patches.forEach(function (patch) {
            var variantId = patch.dataset.id;
            var qty = patch.querySelector(".js-patch-input").value;
            var title = patch.querySelector(".js-patch-title").innerText;

            if (qty > 0) {
                var item = {};
                item.id = variantId;
                item.quantity = qty;
                // item.properties['Free Patch']=`${title}`;
                (item.properties = {
                    "Free Patch": title,
                }),
                    itemsList.push(item);
            }
        });

        setTimeout(function () {
            //addPatchesToCart(patches_to_add, patches);
            var data = {
                items: itemsList,
            };

            $.ajax({
                type: "post",
                url: "/cart/add.js",
                data: data,
                dataType: "json",
                beforeSend: function () {
                    $("#allproductadded").text("adding....");
                },
                success: function (data) {
                    document.dispatchEvent(
                        new CustomEvent("product:added", {
                            bubbles: true,
                            detail: {
                                variant: data.id,
                                quantity: parseInt(data.quantity),
                            },
                        })
                    );
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                    $(".header__cart-dot").addClass("is-visible");
                },
                error: function (resp) {
                    var str = resp.responseText;
                    $("#allproductadded").text("error" + str);
                },
            });
        }, 1000);
    }

    // function addPatchesToCart(itemsToAdd, patches) {
    //   function queue() {
    //     if (itemsToAdd.length) {
    //       var request = itemsToAdd.shift();
    //       var data = {
    //         id: request.id,
    //         quantity: request.quantity,
    //         properties: {
    //           _patches: "true"
    //         }
    //       }

    //       fetch('/cart/add.js', {
    //         method: 'POST',
    //         headers: {
    //           'Content-Type': 'application/json',
    //           'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    //         },
    //         credentials: 'same-origin',
    //         body: JSON.stringify(data)
    //       })
    //       .then(function(res) {

    //         if (itemsToAdd.length === 0) {
    //           document.dispatchEvent(new CustomEvent('product:added', {
    //             bubbles: true,
    //             detail: {
    //               variant: data.id,
    //               quantity: parseInt(data.quantity)
    //             }
    //           }));
    //         };

    //         if (res.ok) {
    //           queue();

    //           patches.forEach(function(patch) {
    //             patch.querySelector('.js-patch-input').value = 0;
    //           })

    //         };

    //       })
    //       .catch(function(err) {
    //         throw new Error(err);
    //         console.error(err);
    //       });
    //     };
    //   };

    //   queue();

    // };

    function calcFreePatches() {
        var productInput = document.querySelector(".quantity-selector__input");
        var patchInputs = Array.prototype.slice.call(
            document.querySelectorAll(".js-patch-input")
        );
        var freePatchCount = document.querySelector(".js-free-count");
        var totalPatchCount;
        var patchInputValues;

        function getTotalPatches() {
            patchInputValues = patchInputs.map((patchInput) => +patchInput.value);
            totalPatchCount = patchInputValues.reduce(function (total, amount) {
                return (total += amount);
            });

            if (productInput.value - totalPatchCount >= 0) {
                freePatchCount.innerHTML = productInput.value - totalPatchCount;
            }
        }

        if (!!patchInputs) {
            patchInputs.forEach(function (patchInput) {
                patchInput.addEventListener("change", getTotalPatches);
            });
        }

        if (!!productInput)
            productInput.addEventListener("change", getTotalPatches);
    }

    calcFreePatches();
    addPatches();
    //add quantity selector of the popup of 26-06-2023
    $(document).ready(function () {
        $(".QuantitySelector__Button").click(function () {
            var quantity = Number(
                $(this)
                    .closest(".product-single__qty-input.add-on-item__input")
                    .find("input")
                    .attr("value")
            );
            if ($(this).hasClass("js-patch-")) {
                if (quantity > 1) {
                    quantity = quantity - 1;
                    $(this)
                        .closest(".product-single__qty-input.add-on-item__input")
                        .find("input")
                        .attr("value", quantity);
                }
            } else {
                quantity = quantity + 1;
                $(this)
                    .closest(".product-single__qty-input.add-on-item__input")
                    .find("input")
                    .attr("value", quantity);
            }
        });
    });
}

/*
 *
 *
 *  Modal Search Functionalities
 *
 *
 */

function patchFiltering() {
    var selectors = {
        $searchContainer: $(".patch-filter-container"),
        $searchInput: $(".patch-filter"),
        $patches: $(".add-on-items"),
        $patch: $(".add-on-item"),
        $noResults: $(".no-results-found"),
    };

    function filterPatches(searchTerm) {
        var text = "";
        var match = 0;
        var noResult = 0;

        if (searchTerm == "") {
            selectors.$patch.slideDown();
            noResult = 1;
            selectors.$noResults.addClass("hide");
        } else {
            selectors.$patch.each(function () {
                text = $(this).text().toLowerCase();
                match = text.indexOf(searchTerm);

                if (match >= 0) {
                    $(this).show();
                    noResult = 1;
                    selectors.$noResults.addClass("hide");
                } else {
                    $(this).hide();
                }
            });
        }

        // returns 'no result' when no results matched
        if (noResult == 0) {
            selectors.$noResults.removeClass("hide");
        }
    }

    // submit on enter
    selectors.$searchInput.keyup(function (e) {
        if (e.which === 13) filterPatches($(this).val().toLowerCase());
    });

    // submit when text field is deselected
    selectors.$searchInput.on("blur", function () {
        filterPatches($(this).val().toLowerCase());
    });
}

//function autoComplete() {
//  var selectors = {
//    $searchContainer: $(".patch-filter-container"),
//    $searchInput: $(".patch-filter"),
//    $patches: $(".add-on-items"),
//    $patch: $(".add-on-item"),
//    $noResults: $(".no-results-found"),
//  };
//
//  //Autocomplete Terms
//  var patches = [];
//
//  //Grab Patch titles to use in autocomplete
//    selectors.$patch.each(function () {
//    patches.push($.trim($(this).find(".add-on-item__title").text()));
//   });
//
//  // Initialize Autocomplete
//  // Library used: https://github.com/devbridge/jQuery-Autocomplete
//
//
//    selectors.$searchInput.autocomplete({
//      appendTo: selectors.$searchContainer,
//      lookup: patches,
//      onSelect: function() {
//        //trigger blur for patch filtering
//        selectors.$searchInput.trigger('blur');
//     }
//    });
//  }


export class PatchesModal {
    constructor() {
        patchModal();
        patchFiltering();
    }
}
const patchesModal = new PatchesModal();
patchesModal;